import { useQuery } from "@tanstack/react-query";
import { DepartmentService } from "../../../../services/department-viags/department.service";
import { useMemo } from "react";
import { flattenWithChildren } from "../utils/flattenWithChildren";
import { sortNestedTree } from "../utils/sortNestedTree";
import { mapNestedTree } from "../utils/mapNestedTree";

export const useDepartments = (departmentCode?: string, departmentId?: number) => {
  const query = useQuery({
    queryKey: ["viags-departments", departmentCode, departmentId],
    queryFn: () => DepartmentService.getDepartmentListV5(departmentCode, departmentId),
  });

  const queryData = useMemo((): any[] => {
    if (!query.data) return [];
    return sortNestedTree(query.data, (a, b) => a.displayOrder - b.displayOrder);
  }, [query.data]);

  const hashedData = useMemo(() => {
    const flatten = flattenWithChildren(queryData);
    const map = new Map();

    flatten.forEach((item) => map.set(item.id, item));

    return map;
  }, [queryData]);

  const treeData = useMemo(() => mapNestedTree(queryData, (item) => ({ title: item.name, key: item.id })), [queryData]);

  return { ...query, data: queryData, treeData, hashedData };
};
